import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "./auth.service";
import { Client } from "../models/client.model";
import { VerifyToken, AccessToken } from "../interfaces/token.interface";

@Injectable({
  providedIn: "root"
})
export class ApiServiceClientsFinance {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) { }

  private optionsHeader = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25",
      Authorization: this.authenticationService.getBearerToken()
    })
  };

  private optionsHeaderNoAuth = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25"
    })
  };

  getClients() {
    return this.http.get<Client[]>(`/clients-finance`, this.optionsHeader);
  }

  verifyToken(idClient: string, data: { code_client: string }) {
    return this.http.post<VerifyToken>(`/clients-finance/login?idClient=${idClient}`, data, this.optionsHeader);
  }

  getToken() {
    return this.http.get<AccessToken>(`/open-finance/get-auth`, this.optionsHeaderNoAuth);
  }
}
